const FULL_POLICY_URL = 'https://magicaltrails.com/privacy';

/**
 * Player-app /privacy-policy. This is a short, accurate summary only — the
 * single authoritative privacy notice lives at magicaltrails.com/privacy and is
 * maintained there. We deliberately do NOT keep a second, independently-editable
 * full policy in the player app; this page always links out to the canonical one.
 */
export default function PrivacyPolicy() {
  return (
    <div className="prose mx-auto w-full break-words p-12">
      <h1>
        <strong>Privacy at Magical Trails</strong>
      </h1>
      <p>
        Magical Trails is operated by Magic Zebra Ltd (registered in England
        &amp; Wales, company no. 17298687), which is the data controller for the
        Service. This page is a short summary — our full, authoritative Privacy
        Policy is kept in one place at{' '}
        <a href={FULL_POLICY_URL} target="_blank" rel="noopener noreferrer">
          magicaltrails.com/privacy
        </a>
        .
      </p>
      <p>In short:</p>
      <ul>
        <li>
          Most trails play anonymously with no account. Your progress and
          preferences are stored on your own device.
        </li>
        <li>
          We use privacy-minimised, session-scoped usage statistics (via
          PostHog) that we do not link to a named account or a persistent
          cross-session identifier. These are on by default; you can turn them
          off any time from the trail menu&rsquo;s &ldquo;Privacy
          choices&rdquo;. Turning them off does not stop the technically
          necessary hosting and security logs needed to run the app.
        </li>
        <li>
          For invite-only trails, we process the email you sign in with to grant
          and manage your access to the trails you were invited to.
        </li>
        <li>
          We do not use children&rsquo;s data for advertising, profiling, or
          cross-service tracking, and we do not sell your personal data.
        </li>
      </ul>
      <p>
        For the complete detail — what we collect, our legal basis, processors,
        international transfers, your rights, retention, and how to contact us or
        delete your data — please read the full policy at{' '}
        <a href={FULL_POLICY_URL} target="_blank" rel="noopener noreferrer">
          magicaltrails.com/privacy
        </a>
        .
      </p>
    </div>
  );
}
